export const goals = [
    "Angular",
    "PWA",
    "Remix",
    "Svelte",
    "Rust",
    "React Native",
]

export default goals;
